import { Stack, Dropdown, Textarea, Box } from 'braid-design-system';
import UploadCandidateAttachment from './UploadCandidateAttachment';
import { ADD_CANDIDATE_FORM_FIELD_NAMES } from './AddCandidateForm';
import type { CandidateAttachment } from './types';
import { COVER_LETTER, RESUME } from '../../../constants/attachmentTypes';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';
import useSourceOptions from './hooks/useSourceOptions';

const sourceOptions = [
  { label: 'Internal Candidate', value: 1 },
  { label: 'Job Board', value: 2 },
  { label: 'Previous Candidate', value: 3 },
  { label: 'Professional Network', value: 4 },
  { label: 'Recruiter', value: 5 },
  { label: 'Referral', value: 6 },
  { label: 'Other', value: 7 },
];

interface Props {
  originId: any;
  notes: any;
  resume: CandidateAttachment;
  setResume: (attachment: CandidateAttachment) => void;
  coverLetter: CandidateAttachment;
  setCoverLetter: (attachment: CandidateAttachment) => void;
}

const StepFour = ({
  originId,
  notes,
  resume,
  setResume,
  coverLetter,
  setCoverLetter,
}: Props) => {
  const { t } = useTranslations(translations);
  const { getSourceOption } = useSourceOptions();
  return (
    <Box marginTop="small">
      <Stack space="large">
        <Box>
          <UploadCandidateAttachment
            attachment={resume}
            setAttachment={setResume}
            fileFieldName="resume"
            attachmentType={RESUME}
          />
        </Box>
        <Box>
          <UploadCandidateAttachment
            attachment={coverLetter}
            setAttachment={setCoverLetter}
            fileFieldName="coverLetter"
            attachmentType={COVER_LETTER}
          />
        </Box>
        <Dropdown
          autoFocus
          label={t('Source')}
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.ORIGIN_ID}
          name="source"
          placeholder={t('Select source')}
          value={originId.value}
          secondaryLabel={t('Optional')}
          onChange={originId.onChange}
        >
          {sourceOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {getSourceOption(option.label)}
            </option>
          ))}
        </Dropdown>

        <Textarea
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.NOTES}
          label={t('Note')}
          secondaryLabel={t('Optional')}
          value={notes.value}
          onChange={notes.onChange}
          onBlur={notes.onBlur}
          tone={notes.valid ? 'neutral' : 'critical'}
          message={!notes.valid && notes.errorMessage}
          reserveMessageSpace
        />
      </Stack>
    </Box>
  );
};

export default StepFour;
